var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "act-login" }, [
    _c("div", { staticClass: "container" }, [
      _vm._m(0),
      _c("div", { staticClass: "form-wrapper" }, [
        _c("div", { staticClass: "input-box" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.phoneNum,
                expression: "phoneNum"
              }
            ],
            attrs: {
              type: "text",
              maxlength: "11",
              onkeyup: "this.value=this.value.replace(/\\D/g,'')",
              onafterpaste: "this.value=this.value.replace(/\\D/g,'')",
              placeholder: "请输入手机号码"
            },
            domProps: { value: _vm.phoneNum },
            on: {
              blur: _vm.checkPhone,
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.phoneNum = $event.target.value
              }
            }
          })
        ]),
        _c("div", { staticClass: "input-box" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.code,
                expression: "code"
              }
            ],
            attrs: {
              maxlength: "4",
              type: "text",
              onkeyup: "this.value=this.value.replace(/\\D/g,'')",
              onafterpaste: "this.value=this.value.replace(/\\D/g,'')",
              placeholder: "请输入验证码"
            },
            domProps: { value: _vm.code },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.code = $event.target.value
              }
            }
          }),
          _vm.verification
            ? _c(
                "span",
                { staticClass: "get-code", on: { click: _vm.getCode } },
                [_vm._v("获取验证码")]
              )
            : _c("span", { staticClass: "get-code" }, [
                _vm._v(_vm._s(_vm.timer) + "s后重新获取")
              ])
        ]),
        _vm.canLogin
          ? _c("div", { staticClass: "button-wrp" }, [
              _c("span", { staticClass: "btn", on: { click: _vm.login } }, [
                _vm._v("注册")
              ])
            ])
          : _c("div", { staticClass: "button-wrp" }, [
              _c("span", { staticClass: "btn no-login" }, [_vm._v("注册")])
            ])
      ]),
      _c(
        "div",
        { staticClass: "footer" },
        [
          _c(
            "van-checkbox",
            {
              model: {
                value: _vm.checked,
                callback: function($$v) {
                  _vm.checked = $$v
                },
                expression: "checked"
              }
            },
            [_c("span", { staticClass: "text whi" }, [_vm._v("我已阅读")])]
          ),
          _c(
            "span",
            {
              staticClass: "text",
              on: {
                click: function($event) {
                  return _vm.openRules(1)
                }
              }
            },
            [_vm._v("《隐私协议》")]
          ),
          _c("span", { staticClass: "text" }),
          _c(
            "span",
            {
              staticClass: "text",
              on: {
                click: function($event) {
                  return _vm.openRules()
                }
              }
            },
            [_vm._v("《用户协议》")]
          )
        ],
        1
      )
    ]),
    _c("img", {
      staticClass: "bg",
      attrs: { src: require("./imgs/login-bg.png"), alt: "" }
    })
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-img" }, [
      _c("img", { attrs: { src: require("./imgs/login-text.png") } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }